import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import { Pie, HorizontalBar, Bar } from "react-chartjs-2"
import colorArray from "helpers/colorArray"
import moment from "moment"
import numeral from "numeral"
import ReactTable from "react-table"
import StackedHorizontalBar from "components/StackedHorizontalBar"
import settings from "settings"
import currentUser from "helpers/currentUser"
import Chart from "react-apexcharts"
import helpers from "helpers/helpers"
let limit = 20

class Dashboard extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	componentDidUpdate(prevProps) {
		//? Paperwork managers should be redirected to the paperwork page, should not have access to the dashboard.
		let user = currentUser()
		let fullUser = _.find(this.props.payload.users, { id: user.id })
		if (fullUser?.paperwork_only) {
			this.props.history.push(`/salesManager/paperwork`)
		}
	}

	builderSales = () => {
		var dataArray = {}
		let model = {}
		_.forEach(this.props.payload.sales.current, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!builder) {
				return
			}
			if (!model.hasOwnProperty(builder.name)) {
				model[builder.name] = 0
			}
		})

		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.builder || v.cancel_date || v.transfer_date) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!type || !v.builder) {
				return
			}

			let path = `${type.name}.${builder.name}`
			if (_.has(dataArray, path)) {
				dataArray[type.name][builder.name]++
			} else {
				dataArray[type.name] = _.clone(model)
				dataArray[type.name][builder.name]++
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.builder || v.cancel_date || v.transfer_date) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!type || !v.builder) {
				return
			}
			let path = `${type.name}.${builder.name}`
			if (_.has(dataArray, path)) {
				dataArray[type.name][builder.name]--
			} else {
				dataArray[type.name] = _.clone(model)
				dataArray[type.name][builder.name]--
			}
		})
		// Create series
		let series = []
		_.forEach(dataArray, (v, k) => {
			series.push({
				name: k,
				data: Object.values(v),
			})
		})
		series = _.sortBy(series, "name")
		return <StackedHorizontalBar series={series} categories={Object.keys(model)} />
	}

	salesBySalespeople = () => {
		var [dataArray, labels, sorted, labelSalespeople, dataSorted] = [{}, [], [], [], []]
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]++
			} else {
				dataArray[v.salesperson] = 1
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]--
			} else {
				dataArray[v.salesperson] = -1
			}
		})

		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}
		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse()
		_.forEach(sorted, (v) => {
			labelSalespeople.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelSalespeople, (v) => {
			let sp = _.find(this.props.payload.public.salespeople, {
				id: parseInt(v),
			})
			if (sp) {
				labels.push(`${sp.first} ${sp.last}`)
			}
		})
		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales ",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		return <HorizontalBar data={data} options={opts} />
	}

	trafficSources = () => {
		// Need to count traffic and sale sources, traffic should come in the payload
		var [labels, dataArray, sorted, f] = [[], {}, [], []]
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.traffic_source) {
				return
			}
			if (v.traffic_source in dataArray) {
				dataArray[v.traffic_source]++
			} else {
				dataArray[v.traffic_source] = 1
			}
		})
		_.forEach(this.props.payload.traffic.split, (v, k) => {
			if (k in dataArray) {
				dataArray[k] += v
			} else {
				dataArray[k] = v
			}
		})
		for (var source in dataArray) {
			sorted.push([source, dataArray[source]])
		}
		sorted
			.sort(function (a, b) {
				return a[1] - b[1]
			})
			.reverse()
		_.forEach(sorted, (v) => {
			if (v[0] !== "0") {
				f.push(v[1])
				let b = _.find(this.props.payload.public.trafficSources, {
					id: parseInt(v[0]),
				})
				labels.push(`${b.name}`)
			}
		})
		labels = labels.slice(0, limit)
		f = f.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sold",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: f,
				},
			],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	floorplans = () => {
		var [labels, floorplans, sorted, labelFloorplans, dataSorted] = [[], [], [], [], []]
		_.forEach(this.props.payload.sales.current, (v, k) => {
			if (!v.floorplan || v.transfer_date) {
				return
			}
			//var floorplanName = this.props.payload.floorplans[v.floorplan]
			if (v.floorplan in floorplans) {
				floorplans[v.floorplan]++
			} else {
				floorplans[v.floorplan] = 1
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v, k) => {
			if (!v.floorplan || v.transfer_date) {
				return
			}
			//var floorplanName = this.props.payload.floorplans[v.floorplan]
			if (v.floorplan in floorplans) {
				floorplans[v.floorplan]--
			} else {
				floorplans[v.floorplan] = -1
			}
		})
		for (var prop in floorplans) {
			sorted.push([prop, floorplans[prop]])
		}

		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse().slice(0, limit)
		_.forEach(sorted, (v) => {
			labelFloorplans.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelFloorplans, (v) => {
			v = parseInt(v)
			if (isNaN(v)) {
				return
			}
			let b = _.find(this.props.payload.public.floorplans, {
				id: parseInt(v),
			})
			if (b) {
				labels.push(`${b.name}`)
			}

			//labels.push(this.props.payload.public.floorplans[v])
		})
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
			definitions: [],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
			tooltips: {
				callbacks: {
					label: (tooltipItems, data) => {
						let fp = _.find(this.props.payload.public.floorplans, { name: tooltipItems.label })
						let builder
						if (fp) {
							builder = _.find(this.props.payload.public.builders, { id: fp.builder })
						}
						return builder ? `${builder.name} - ${tooltipItems.yLabel}` : tooltipItems.yLabel
					},
				},
			},
		}
		return <HorizontalBar data={data} options={opts} />
	}

	realtorPercent = () => {
		let count = 0
		let total = 0
		let percent = 0
		for (let v of this.props.payload.sales.current) {
			if (v.transfer_date || v.bustout_date) {
				continue
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}
		//console.log(count, total)
		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = Math.round(percent * 100)

		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Realtor Sales")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
				<p className="gauge__copy">{count} Realtor Sales</p>
			</div>
		)
	}

	bustRate = () => {
		let percent = this.props.payload.bustouts.current.length / this.props.payload.sales.current.length
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = Math.round(percent * 100)
		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	lotTypes = () => {
		// First compile a list of all types
		let t = []
		for (let v of this.props.payload.sales.current) {
			t.push(v.lot_type)
		}
		for (let v of this.props.payload.bustouts.current) {
			t.push(v.lot_type)
		}
		t = _.uniq(t)
		let types = {}
		for (let v of t) {
			let type = _.find(this.props.payload.public.lot_types, { id: v })
			if (type) {
				types[type.name] = 0
			}
		}

		for (let v of this.props.payload.sales.current) {
			if (v.transfer_date || v.cancel_date) {
				continue
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (type) {
				types[type.name]++
			}
		}
		for (let v of this.props.payload.bustouts.current) {
			if (v.transfer_date || v.cancel_date) {
				continue
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (type) {
				types[type.name]--
			}
		}

		const data = {
			labels: _.keys(types),
			datasets: [
				{
					data: _.values(types),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return <Pie data={data} options={opts} />
	}

	countGross = () => {
		// in place because a sale could have transferred or canned (not busted)
		let i = 0
		let c = 0
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date || v.cancel_date) {
				return
			}
			i++
		})
		if (this.props.compareStatus) {
			_.forEach(this.props.payload.sales.compare, (v) => {
				if (v.transfer_date || v.cancel_date) {
					return
				}
				c++
			})
		}

		return [i, c]
	}

	dirtVsSpec = () => {
		//var [dirt, spec] = [[], []]
		let dirt = 0
		let spec = 0
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date) {
				return
			}
			if (v.start_date && v.start_date <= v.sale_date) {
				spec++
			} else {
				dirt++
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.transfer_date) {
				return
			}
			if (v.start_date && v.start_date <= v.sale_date) {
				spec--
			} else {
				dirt--
			}
		})
		const data = {
			labels: ["Breakout"],
			datasets: [
				{
					label: "Dirt",
					backgroundColor: "#3295EC",
					borderColor: "#3295EC",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [dirt],
				},
				{
					label: "Spec",
					backgroundColor: "#ee7883",
					borderColor: "#ee7883",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [spec],
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: {
					clamp: true,
				},
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	realtorInvolved = () => {
		let yes = 0
		let no = 0
		let total = 0
		for (let v of this.props.payload.sales.current) {
			if (v.transfer_date || v.bustout_date) {
				continue
			}
			if (v.realtor_involved === 1) {
				yes++
			} else {
				no++
			}
			total++
		}
		//console.log(yes, no, total)
		const data = {
			labels: ["Breakout"],
			datasets: [
				{
					label: "Yes",
					backgroundColor: "#3295EC",
					borderColor: "#3295EC",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [yes],
				},
				{
					label: "No",
					backgroundColor: "#76B9F1",
					borderColor: "#3295EC",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [no],
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: {
					clamp: true,
				},
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	calcStarts = () => {
		// in place because a sale could have transferred or canned (not busted)
		let i = 0
		_.forEach(this.props.payload.salesManagerPayload.lots, (v) => {
			if (
				v.start_date >= this.props.currentDates.startStamp &&
				v.start_date <= this.props.currentDates.endStamp &&
				this.props.activeProperties.includes(v.property)
			) {
				i++
			}
		})

		return i
	}

	inventoryStatus = () => {
		// First compile a list of all statuses
		let statuses = {
			"Pending Sale": 0,
			"Closed to Homebuyer": 0,
			"Sales Opportunities": 0,
		}
		let count = 0
		_.forEach(this.props.payload.salesManagerPayload.lots, (v) => {
			if (!this.props.activeProperties.includes(v.property)) {
				return
			}
			if (v.closing_date) {
				statuses["Closed to Homebuyer"]++
			} else if (v.sale_id) {
				// active sale - can use just sale_id because if it were closed it would have gotten caught before this
				statuses["Pending Sale"]++
			} else {
				statuses["Sales Opportunities"]++
			}
			count++
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Inventory Status (Life of Project)
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	salesOpportunities = () => {
		// First compile a list of all statuses
		let statuses = {
			"Specs Under Construction": 0,
			"Completed Specs": 0,
			Models: 0,
			"Vacant Lot Inventory": 0,
		}
		let count = 0
		_.forEach(this.props.payload.salesManagerPayload.lots, (v) => {
			if (v.sale_date || !this.props.activeProperties.includes(v.property)) {
				return
			}
			if (v.model == 1) {
				statuses["Models"]++
			} else if (v.start_date && !v.complete_date) {
				statuses["Specs Under Construction"]++
			} else if (v.complete_date) {
				statuses["Completed Specs"]++
			} else if (!v.start_date) {
				statuses["Vacant Lot Inventory"]++
			}
			count++
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Sales Opportunity Breakdown
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	builderVacantLots = () => {
		// First compile a list of all statuses
		let statuses = {
			"Builder Owned": 0,
			"Developer Owned (SC) – Contracted to Builder": 0,
			"Developer Owned (UC) – Contracted to Builder": 0,
		}
		let count = 0
		_.forEach(this.props.payload.salesManagerPayload.lots, (v) => {
			if (
				v.start_date ||
				v.complete_date ||
				v.closing_date ||
				v.sale_id ||
				v.model == 1 ||
				v.buyer_id ||
				!this.props.activeProperties.includes(v.property)
			) {
				return
			}
			if (v.takedown_date) {
				statuses["Builder Owned"]++
			} else if (!v.takedown_date && v.builder && v.substantially_complete) {
				statuses["Developer Owned (SC) – Contracted to Builder"]++
			} else if (v.builder && !v.substantially_complete) {
				statuses["Developer Owned (UC) – Contracted to Builder"]++
			}
			count++
		})
		//
		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Vacant Lot Inventory
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	calcTraffic = () => {
		let user = currentUser()
		let c = 0
		let total = 0
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			if (this.props.activeProperties.includes(v.property) && user.builders.includes(v.builder)) total++
		})
		_.forEach(this.props.payload.traffic.current.grouped.array, (v) => {
			if (this.props.activeProperties.includes(v.property) && user.builders.includes(v.builder)) {
				total += v.prospect_count
				total += v.realtor_count
			}
		})
		if (this.props.compareStatus) {
			c = this.props.payload.traffic.compare.entries.length + this.props.payload.exec.traffic.grouped_total
		}
		return [total, c]
	}

	builderAverages = () => {
		// build averages
		let s = {},
			ret = {}
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (!v.builder || v.bustout_date || v.cancel_date || v.transer_date) {
				return
			}
			if (!_.has(s, `${v.builder}`)) {
				_.set(s, `${v.builder}.sqft`, 0)
				_.set(s, `${v.builder}.amount`, 0)
				_.set(s, `${v.builder}.count`, 0)
			}
			s[v.builder].count++
			s[v.builder].amount += v.price
			s[v.builder].sqft += v.sqft
		})
		//console.log(s)
		let i = 1
		_.forEach(s, (v, k) => {
			ret[i] = {
				amount: Math.ceil(v.amount),
				sqft: v.sqft,
				count: v.count,
				builder: k,
				averagePrice: Math.ceil(v.amount / v.count),
				averagePpsqft: v.sqft ? Math.ceil(v.amount / v.sqft) : 0,
				averageSqFt: Math.ceil(v.sqft / v.count),
			}
			i++
		})
		var data = _.map(ret, (v) => {
			let b = _.find(this.props.payload.public.builders, {
				id: parseInt(v.builder),
			})
			let name = ""
			if (b) {
				name = b.name
			}
			return {
				builder: name,
				total: v.count,
				averagePPSQFT: v.averagePpsqft,
				averageOffered: v.averagePrice,
				averageSqFt: v.averageSqFt,
			}
		})
		const columns = [
			{
				Header: "Builder",
				accessor: "builder",
				className: "small",
			},
			{
				Header: "Total Sales (Life of Project)",
				accessor: "total",
				Cell: (props) => numeral(props.value).format("0,0"),
			},
			{
				Header: "Average $ Amount",
				accessor: "averageOffered",
				Cell: (props) => numeral(props.value).format("$0,0"),
				sort: "desc",
				headerClassName: "wrap small",
			},
			{
				Header: "Average Square Footage",
				accessor: "averageSqFt",
				Cell: (props) => numeral(props.value).format("0,0"),
			},
			{
				Header: "Average Price/Sq Ft",
				accessor: "averagePPSQFT",
				headerClassName: "wrap small",
				Cell: (props) => numeral(props.value).format("$0,0"),
			},
		]

		return <ReactTable loadingText="" data={data} columns={columns} defaultPageSize={15} loadingText="" />
	}

	salesMeter = () => {
		let projected = 0
		let total = 0
		let current = 0
		let previous = 0

		_.forEach(this.props.activeProperties, (v) => {
			let details = _.find(this.props.payload.public.properties, { id: v })
			if (details) {
				projected += details.current_projected
				total += details.totalProjected
				current += details.thisYearNet
				previous += details.lastYearNet
			}
		})
		let currentPercent = (current / total) * 100
		let projectedPercent = (projected / total) * 100
		let previousPercent = (previous / total) * 100
		return (
			<div className="meter__cont">
				<div className="meter">
					<div className="meter__fill" style={{ width: currentPercent + "%" }}>
						<span>
							{current.toLocaleString()} Net ({Math.round(currentPercent)}%)
						</span>
					</div>
					<div className="meter__projected" style={{ left: projectedPercent + "%" }}>
						<span>
							{projected.toLocaleString()} Projected ({Math.round(projectedPercent)}%)
						</span>
					</div>
					<div className="meter__previous" style={{ left: previousPercent + "%" }}>
						<span>
							{previous.toLocaleString()} Previous Year ({Math.round(previousPercent)}%)
						</span>
					</div>
				</div>
				<div className="meter__total">{total.toLocaleString()} Projected Annual Sales Goal</div>
			</div>
		)
	}

	render() {
		let user = currentUser()
		if (this.props.payloadStatus) {
			let builderString = ""
			_.forEach(user.builders, (v) => {
				try {
					let builder = _.find(this.props.payload.public.builders, { id: v })
					if (!builder) throw new Error(`Cannot find builder for builderID: ${v}`)
					builderString += `${builder.name} / `
				} catch (e) {
					console.log(e)
				}
			})
			builderString = builderString.replace(/ \/ $/, "")
			return (
				<div>
					<div className="imageGroup">
						<Title title={`Dashboard - ${builderString}`} compare={false} />
						<div className="quickStats">
							<ul className="quickStats__list">
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{this.countGross()[0].toLocaleString()}</div>
										{this.props.compareStatus && (
											<div className="quickStats__compare">{this.countGross()[1]}</div>
										)}
										<div className="quickStats__type">Gross Sales</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{this.countGross()[0] - this.props.payload.bustouts.current.length}
										</div>
										{this.props.compareStatus && (
											<div className="quickStats__compare">
												{this.props.payload.bustouts.compare.length}
											</div>
										)}
										<div className="quickStats__type">Net Sales</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{this.props.payload.bustouts.current.length.toLocaleString()}
										</div>
										{this.props.compareStatus && (
											<div className="quickStats__compare">
												{this.props.payload.bustouts.compare.length.toLocaleString()}
											</div>
										)}
										<div className="quickStats__type">Cancellations</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{this.props.payload.closings.current.length.toLocaleString()}
										</div>
										{this.props.compareStatus && (
											<div className="quickStats__compare">
												{this.props.payload.closings.compare.length.toLocaleString()}
											</div>
										)}
										<div className="quickStats__type">Closings</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">{this.calcStarts()}</div>
										<div className="quickStats__type">Starts</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{numeral(this.calcTraffic()[0]).format("0,0")}
										</div>
										{this.props.compareStatus && (
											<div className="quickStats__compare">
												{/* numeral(
													this.calcTraffic()[1] - this.props.payload.bustouts.compare.length
												).format("0,0") */}
											</div>
										)}
										<div className="quickStats__type">Traffic Entries</div>
									</div>
								</li>
							</ul>
						</div>
						<div className="statBox">
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<h3 className="statBox__title">Realtor Sales</h3>
									{this.realtorPercent()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Cancellation Rate</h3>
									{this.bustRate()}
								</div>
							</div>
							<div className="statBox__row statBox__row--triple">
								<div className="statBox__box">
									<h3 className="statBox__title">Sales By Lot Type</h3>
									{this.lotTypes()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Sales Dirt vs Spec</h3>
									{this.dirtVsSpec()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Realtor Involved?</h3>
									{this.realtorInvolved()}
								</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox">
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<h3 className="statBox__title">Builder Sales</h3>
									{this.builderSales()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Top Selling Floorplans</h3>
									{this.floorplans()}
								</div>
							</div>
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<h3 className="statBox__title">
										Sales by Salespeople
										<span className="subhead">Top 20</span>
									</h3>
									{this.salesBySalespeople()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Top Performing Traffic Sources</h3>
									{this.trafficSources()}
								</div>
							</div>
							<div className="statBox__row statBox__row--triple">
								<div className="statBox__box">{this.inventoryStatus()}</div>
								<div className="statBox__box">{this.salesOpportunities()}</div>
								<div className="statBox__box">{this.builderVacantLots()}</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="footnotes">
							<h3>Footnotes</h3>
							<ol>
								<li>Delivered: Sections which are substantially complete.</li>
								<li>
									Pending: Sections which are not yet substantially complete, but are in lot purchase
									contracts to builders and are pre-sale opportunities.
								</li>
							</ol>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
		compareStatus: state.compareStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Dashboard)
